import React from "react";
import { buildOptions } from "../../../utils";
import TextField from "../../../fields/TextField";
import SelectField from "../../../fields/SelectField";
import BooleanField from "../../../fields/BooleanField";

export const Demographics = () => {
  const genderOptions = buildOptions(["Male", "Female", "Trans", "Non-Binary"]);
  const maritalStatusOptions = buildOptions([
    "Single",
    "Married",
    "Divorced",
    "Separated",
    "Widowed",
  ]);
  const raceOptions = buildOptions([
    "American Indian or Alaska Native ",
    "Indian",
    "Asian",
    "Black or African American",
    "White",
    "Hispanic",
    "Hawaiian or Other Pacific Islander",
  ]);
  const ethnicityOptions = buildOptions([
    "Hispanic or Latino or Spanish Origin",
    "Not Hispanic or Latino or Spanish Origin",
  ]);
  const veteranStatusOptions = buildOptions([
    "Yes",
    "No",
    "Disabled veteran",
    "Recently separated veteran",
    "Active Duty Wartime or Campaign Badge Veteran",
    "Armed Forces Service Medal Veteran"
  ]);

  return (
    <div className="p-4">
      <SelectField
        name="gender"
        label="Gender"
        options={genderOptions}
        creatable
        action="edit"
        col="none"
      />
      <TextField name="school" label="School" action="edit" col="none" />
      <SelectField
        name="marital_status"
        label="Marital Status"
        options={maritalStatusOptions}
        action="edit"
        col="none"
      />
      <SelectField
        name="race"
        label="Race"
        options={raceOptions}
        creatable
        action="edit"
        col="none"
      />
      <SelectField
        name="ethnicity"
        label="Ethnicity"
        options={ethnicityOptions}
        creatable
        action="edit"
        col="none"
      />
      <SelectField
        name="veteran_status"
        label="Veteran"
        options={veteranStatusOptions}
        creatable
        action="edit"
        col="none"
      />
    </div>
  );
};
